
import {useTranslation} from "react-i18next";

import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";



import "react-datepicker/dist/react-datepicker.css";
import Style from "./violations/modalEditTicket.module.css";
import LabelWithHR from "../common/labels/labelWithHR";
import { newModalStyle } from "../reusable/styles";
import { Label } from "@material-ui/icons";
import zIndex from "@mui/material/styles/zIndex";

export const pageTitleStyle = {
  fontFamily: "Gilroy-Bold",
  fontSize: 20,
  fontWeight: "bold",
  fontStyle: "normal",
  textAlign: "left",
  letterSpacing: 0,
  color: "#000000",
  marginBottom: "15px",
  marginTop: "15px",  
  paddingLeft: "15px"
};
export const minorTitleStyle = {
  fontFamily: "Gilroy-Bold",
  fontSize: 16,
  fontWeight: "bold",
  fontStyle: "normal",
  textAlign: "left",
  letterSpacing: 0,
  color: "#000000",
  paddingLeft: "15px"  
};

export const descStyle = {
  fontFamily: "Gilroy-Regular",
  fontSize: 18,
  fontStyle: "normal",
  textAlign: "left",
  letterSpacing: 0,
  color: "#000000",
  marginBottom: "15px",
  paddingRight: "10px"
};

const HelpModal = (props) => {
  const { t, i18n } = useTranslation();
    
  return (
    <Modal
    open={props.open}
    onClose={props.onClose}
    center
    container={document.body}
    styles={newModalStyle({ width: "600px", zIndex: 20000 })}
    >
    {props.type =="userStatus" && <div>
        <div className="modal__title" style={pageTitleStyle}>
            {t("Help.UserStatus.Title")}
        </div>
        <div style={descStyle}>
            <ul>
                <li style={{paddingBottom : 5}}>{t("Help.UserStatus.OpenExplaination")}</li>
                <li style={{paddingBottom : 5}}>{t("Help.UserStatus.ClosedExplaination")}</li>
                <li style={{paddingBottom : 5}}>{t("Help.UserStatus.CancelledExplaination")}</li>
                <li>{t("Help.UserStatus.PaidExplaination")}</li>                                    
            </ul>


        </div>
    </div>}
    {props.type =="statusInformation" && <div>
        <div className="modal__title" style={pageTitleStyle}>
            {t("Help.StatusInformation.Title")}
        </div>
        <div className="modal__title" style={minorTitleStyle}>
            {t("Help.StatusInformation.ClosedCases.Title")}
        </div>
        <div style={descStyle}>
            <ul>
                <li style={{paddingBottom : 5}}>{t("Help.StatusInformation.ClosedCases.reportedToThePoliceExplaination")}</li>
                <li style={{paddingBottom : 5}}>{t("Help.StatusInformation.ClosedCases.insufficientEvidenceExplaination")}</li>
                <li style={{paddingBottom : 5}}>{t("Help.StatusInformation.ClosedCases.noFollowUpExplaination")}</li>                      
            </ul>
        </div>
        <div className="modal__title" style={minorTitleStyle}>
            {t("Help.StatusInformation.CancelledCases.Title")}
        </div>
        <div style={descStyle}>
            <ul>
                <li>{t("Help.StatusInformation.CancelledCases.reportedToThePoliceExplaination")}</li>                      
            </ul>
        </div>        
    </div>}

    </Modal>
  );
};
export default HelpModal;